export default function QualStats() {
  return <div>QualStats</div>
}
